export default __webpack_public_path__ + "static/media/refresh-grey.485846b6.svg";